@if (spaBooking(); as spaBooking) {
  @if (spaBooking.items.length > 1) {
    <div appAutoClose="always" class="relative mt-3 basis-1/2 h-24">
      <button aria-labelledby="spaItemChoice"
              class="bg-gray-100 py-5 px-4 pr-10 md:px-7 hover:bg-gray-200 duration-200 cursor-pointer relative w-full rounded-md text-left text-gray-900 focus:outline-none"
              type="button">
        <div class="flex items-center">
          <div class="w-12">
            <img alt="{{ selectedSpaItem()?.label }}" class="h-9 w-9 flex-shrink-0 m-auto" height="60"
                 ngSrc="assets/icons/gray/spa.svg"
                 width="60">
          </div>
          <div class="truncate text-gray-500 font-semibold text-lg ml-4 md:ml-6">
            <p class="font-semibold truncate text-xs" id="spaItemChoice">{{ 'yourPass' | translate }}</p>
            {{ selectedSpaItem()?.label }}
          </div>
        </div>
        <div class="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-6">
          <img alt="" class="h-4 w-4" height="60" ngSrc="assets/icons/gray/down.svg" width="60">
        </div>
      </button>
      <ul class="hidden absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg
        ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
        @for (item of spaBooking.items; track item.erpId; let first = $first) {
          <li [attr.aria-selected]="selectedSpaItem()?.erpId === item.erpId"
              class="text-gray-900 hover:bg-gray-100 relative select-none md:px-5 cursor-pointer">
            <button (click)="selectSpaItem(item)" class="flex items-center py-4 px-3 w-full">
              <span [ngClass]="selectedSpaItem()?.erpId === item.erpId ? 'font-semibold' : 'font-normal'"
                    class="text-lg text-gray-500 ml-3 block truncate">
                {{ item.label }}
              </span>
            </button>
          </li>
        }
      </ul>
    </div>
  }
}
@if (selectedSpaItem(); as selectedSpaItem) {
  <div class="flex flex-col gap-12 md:flex-row place-content-between relative">
    <div class="grow">
      <div class="h-20 flex items-center border-b border-gray-200 gap-4 mb-5">
        <svg class="fill-bleuCaliceo-300 h-10 w-10" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"/>
        </svg>
        <p class="text-xl text-bleuCaliceo-300 font-semibold">{{ 'nextSessionTitle' | translate }}</p>
      </div>
      @if (updatePlanningProgress()) {
        <div class='w-full'>
          <div class='h-1 w-full bg-gray-300 overflow-hidden'>
            <div class='progress w-full h-full bg-bleuCaliceo-300 left-right'></div>
          </div>
        </div>
      } @else {
        @if (availableDays().length) {
          <app-date-picker (selectedDataChange)="selectDay($event)" [customs]="availableDays()"
                           [notAfter]="selectedPeriod().to" [notBefore]="selectedPeriod().from"
                           defaultClasses="line-through"
          ></app-date-picker>
        } @else {
          <p class="text-gray-500 font-semibold">{{ 'noSpaAvailabilities' | translate }}
            <a class="font-bold text-bleuCaliceo-300" href="mailto:{{spaEmail()}}">{{ spaEmail() }}</a>.</p>
        }
      }
    </div>
    @if (!updatePlanningProgress()) {
      @if (availableSlots(); as slots) {
        <div #timeSlots>
          <div class="h-20 flex items-center border-b border-gray-200 gap-4 mb-5">
            <p class="text-gray-500 font-semibold">{{ 'selectAnHour' | translate }}</p>
          </div>
          <div class="h-80 overflow-y-auto flex flex-col gap-2">
            @for (slot of slots; track slot) {
              <button (click)="selectSlot(slot)" (keyup.enter)="emulateClick($event)" [disabled]="selectSlotProgress()"
                      [ngClass]="{
                    'border-bleuCaliceo-300 bg-bleuCaliceo-300 text-white': selectedSlot() === slot,
                    'disabled:bg-gray-300 disabled:text-white': selectedSlot() !== slot
                    }"
                      class="flex flex-row cursor-pointer w-100 text-gray-800 text-center font-semibold
                    border-2 border-gray-200 rounded-lg place-content-between p-4 hover:border-bleuCaliceo-300
                    hover:bg-bleuCaliceo-300 hover:text-white"
                      onKeyUp
                      tabindex="0">
                <p class="grow w-8/12"> {{ slot }} </p>
                @if (selectSlotProgress() && selectedSlot() === slot) {
                  <svg class="animate-spin h-6 w-6 text-white" fill="none"
                       viewBox="0 0 24 24"
                       xmlns="http://www.w3.org/2000/svg">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          fill="currentColor"></path>
                  </svg>
                }
              </button>
            }
          </div>
        </div>
      }
    }
    @if (actualSlot(); as slot) {
      <div class="absolute left-2 right-2 bottom-40 md:top-12 md:bottom-12 md:left-12 md:right-12 m-auto">
        <div class="shadow-2xl shadow-gray-700 rounded-xl bg-white p-4">
          <p class="font-semibold text-gray-800 mb-6">{{ 'reservationFor' | translate }} :</p>
          <div class="flex gap-3">
            <svg class="w-10 h-6 fill-gray-500" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"/>
            </svg>
            <p class="text-bleuCaliceo-300 text-center whitespace-pre-line">
              <span class="font-semibold">{{ selectedSpaItem?.label }}</span>
              @if (duo()) {
                <span class="ml-2 align-middle inline-block rounded-full bg-vertCaliceo-500 px-3 py-0.5 text-xs font-bold uppercase text-white">
                  {{ 'duoTag' | translate }}
                </span>
              }<br>
              {{ 'bookedFor.v2' | translate : { date: (selectedDay()?.date | date), time: slot } }}
            </p>
          </div>
          <div class="relative mt-4">
            <textarea [attr.aria-describedby]="'spaCommentCount-' + id"
                      [formControl]="commentaireControl"
                      [id]="'spaComment-' + id"
                      [maxlength]="AQUAO_TEXT_UX_MAX"
                      [placeholder]="'spaCommentHint' | translate"
                      class="px-4 pt-6 pb-2 rounded-lg border-none w-full bg-gray-100 font-medium text-base resize-none placeholder:text-gray-400 placeholder:font-normal placeholder:text-sm"
                      rows="3"></textarea>
            <label [for]="'spaComment-' + id" class="absolute text-xs text-gray-500 top-1 z-10 left-4 pt-1">
              {{ 'spaComment' | translate }}
            </label>
            <app-character-count [attr.id]="'spaCommentCount-' + id" [max]="AQUAO_TEXT_UX_MAX"
                                 [value]="commentaireControl.value"/>
          </div>
          <div class="px-6 flex gap-4 mt-4">
            <button (click)="actualSlot.set(null)" class="grow py-3 main-btn bg-gray-400 hover:bg-gray-300">
              {{ 'cancel' | translate }}
            </button>
            <button [appProgressClick]="planSpa"
                    appHoverGradient class="grow py-3 main-btn">
              {{ 'validate' | translate }}
            </button>
          </div>
        </div>
      </div>
    }
  </div>
} @else {
  <div class='w-full mt-14 h-12'>
    <div class='h-1.5 w-full bg-gray-300 overflow-hidden'>
      <div class='progress w-full h-full bg-bleuCaliceo-300 left-right'></div>
    </div>
  </div>
}
